/** True when this location holds hardware and home delivery is not a real choice. */
export function forcesLocalPickup(location, org) {
    if (org && org.use_government_mode) return true;
    if (!location) return false;
    return !!location.force_location_fulfillment;
}
